import { CallingTheme, VideoTileStylesProps } from "@azure/communication-react";
import { memoizeFunction, Theme } from "@fluentui/react";

export const videoTileStyle = memoizeFunction(
    (themeV8: Theme & CallingTheme, raisedHand?: boolean): VideoTileStylesProps => ({
            root: {
                '&::after': raisedHand ? {
                    content: `''`,
                    position: 'absolute',
                    border: `0.25rem solid ${themeV8.callingPalette.raiseHandGold}`,
                    borderRadius: themeV8.effects.roundedCorner4,
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none'
                } : {},
            }
        })
);